<template>
  <header class="header" id="top">
    <section class="header-container adaption">
      <img class="header-logo" v-lazy="require('../assets/image/logo.png')"/>
      <div style="display: flex">
        <div class="menu-container">
          <ul class="menu">
            <li
              v-for="(value, key) in routeMap"
              :key="value"
              class="menu-item"
              :class="activeRoute === value ? 'active' : ''"
              @click="push(value)"
              @mouseover="saveHoveredKey(value)"
              @mouseleave="hideDiv"
            >
              {{ key }}
            </li>
          </ul>
        </div>
        <!--            <div class="phone">-->
        <!--                <img v-lazy="require('../assets/home/email.svg')"/>-->
        <!--                <span class="tx">service@dualpi.com</span>-->
        <!--            </div>-->
        <div class="btn-list">
          <div class="login" @click="login" v-if="isShow">
            <span>登录</span>
          </div>
          <div class="register" @click="register" v-if="isShow">
            <span>注册</span>
          </div>
          <div class="regist" v-if="isedShow">
            <span>已登录</span>
          </div>
          <div class="register" @click="signOut" v-if="isedShow">
            <span>退出</span>
          </div>
        </div>
      </div>
    </section>
    <transition name="slide-down">
      <div class="animated-div" v-show="showVariables.show1"  @mouseover="showDiv" @mouseleave="hideDiv">
        <div class="animated-bg"></div>
        <div class="animated-box">

          <div class="product-header-box-slide product-gap">
            <div>
              <div class="full-scene">
                <div class="title">安全产品全景视图</div>
<!--                <div class="describe">360全视野产品架构展示，真实物理环境模拟</div>-->
                <div class="details" @click="productView">了解详情</div>
              </div>
            </div>
<!--            <div style="display: flex;" v-for="(items, index) in productResultArray" :key="index">-->
<!--              <div>-->
<!--                <div class="title">工控产品</div>-->
<!--                <div class="sub-title" v-for="(item, index) in items" :key="index" @click="productViewList">{{item.title}}</div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="region-box">
              <div class="title">全领域安全产品</div>
              <div class="region-item-box">
                <div v-for="(item, index) in productionList" :key="index" class="region-item">
                  <div class="product-title">{{item.name}}</div>
                  <div class="sub-title" v-for="(items, subIndex) in item.subList" :key="subIndex"
                       @click="productViewList(items.name,item.name)">{{items.name}}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="educate-box">
                <div class="title">教育与研究</div>
                <div class="sub-title" @click="productViewPlatform">工业互联网攻防实验与教学平台</div>
                <div class="sub-title" @click="productViewPlatform">工业互联网安全实验箱</div>
                <div class="sub-title" @click="productViewPlatform">工业互联网安全综合测试系统</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>

    <transition name="slide-down">
      <div class="animated-div" v-show="showVariables.show2" @mouseover="showDiv" @mouseleave="hideDiv">
        <div class="animated-bg"></div>
        <div class="animated-box">

          <div class="product-header-box-slide">
            <div v-for="(item, index) in solutionList" :key="index" class="header-item">
              <div>
                <div class="title">{{item.name}}</div>
                <div class="sub-title" v-for="(items, subIndex) in item.subList" :key="subIndex"
                     @click="jumpSolutionView(item.id,items.id)">{{items.name}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>

    <transition name="slide-down">
      <div class="animated-div" v-show="showVariables.show3" @mouseover="showDiv" @mouseleave="hideDiv">
        <div class="animated-bg"></div>
        <div class="animated-box">

          <div class="product-header-box-slide">
            <div v-for="(item, index) in serviceList" :key="index" class="header-item">
              <div>
                <div class="title">{{item.name}}</div>
                <div class="sub-title" v-for="(items, subIndex) in item.subList" :key="subIndex"
                     @click="jumpServiceView(index, subIndex)">{{items.name}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>

<!--    <transition name="slide-down">-->
<!--      <div class="animated-div" v-show="showVariables.show4" @mouseover="showDiv" @mouseleave="hideDiv">-->
<!--        <div class="animated-box">-->

<!--          <div class="product-header-box-slide">-->
<!--            <div>-->
<!--              <div class="title">全部</div>-->
<!--              <div class="describe">360全视野产品架构展示，真实物理环境模拟</div>-->
<!--              <div class="details" @click="caseView">了解详情</div>-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--            <div>-->
<!--              <div class="title">智能制造</div>-->
<!--              <div class="sub-title">淮北智慧煤矿工业2.0</div>-->
<!--              <div class="sub-title">淮北智慧煤矿工业2.0</div>-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--            <div>-->
<!--              <div class="title">智能制造</div>-->
<!--              <div class="sub-title">淮北智慧煤矿工业2.0</div>-->
<!--              <div class="sub-title">淮北智慧煤矿工业2.0</div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->

<!--    <transition name="slide-down">-->
<!--      <div class="animated-div" v-show="showVariables.show5" @mouseover="showDiv" @mouseleave="hideDiv">-->
<!--        <div class="animated-box">-->

<!--          <div class="product-header-box-slide">-->
<!--            <div>-->
<!--              <div class="title" style="width: 200px;cursor: pointer;" @click="jumpLapView('1')">实验室介绍</div>-->
<!--&lt;!&ndash;              <div class="sub-title">实验室1</div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="sub-title">实验室2</div>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--            <div>-->
<!--              <div class="title" style="width: 200px;cursor: pointer;" @click="jumpLapView('2')">研究成果</div>-->
<!--&lt;!&ndash;              <div class="sub-title">实验室1</div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="sub-title">实验室2</div>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--            <div>-->
<!--              <div class="title" style="width: 200px;cursor: pointer;" @click="jumpLapView('3')">政策法规</div>-->
<!--&lt;!&ndash;              <div class="sub-title">实验室1</div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="sub-title">实验室2</div>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--            <div>-->
<!--              <div class="title" style="width: 200px;cursor: pointer;" @click="jumpLapView('4')">特征库更新</div>-->
<!--&lt;!&ndash;              <div class="sub-title">实验室1</div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="sub-title">实验室2</div>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="line"></div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->

  </header>
</template>

<script>
import {mapState} from "vuex";
import {newsApi} from "@/service/api/node";
import store from "@/store";

export default {
  name: "header",
  computed: {
    ...mapState("menu", ["activeRoute", "routeMap","solutionList","serviceList","productionList"])
  },
  inject:["reload"],
  data() {
    return {
      isShow: true,
      isedShow: false,
      cookieInfo: "",
      hoveredKey: null,
      showVariables: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      },
      keyDict: ["product", "solution", "service"],
      showAnimatedDiv: false,
      // serviceTypeList: [],
      // solutionList: [],
      allProduct: [],
      productResultArray: []
    };
  },
  watch: {
  },
  created() {
    this.getCookie();
  },
  mounted() {
    // this.serviceTypeList = JSON.parse(window.localStorage.getItem("serviceTypeList"));
    // this.solutionList = JSON.parse(window.localStorage.getItem("solutionList"));
    this.allProduct = JSON.parse(window.localStorage.getItem("allProduct"));
    this.productResultArray = this.chunkArray(this.allProduct, 8);
  },
  methods: {
    chunkArray(array, chunkSize) {
      let result = [];

      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    },
    push(value) {
      this.$router.push("/" + value);
    },
    login() {
      let urlString = document.domain;

      window.open("http://" + urlString + ":8080" + "/login");
    },
    register() {
      let urlString = document.domain;

      window.open("http://" + urlString + ":8080" + "/register");
    },
    checkLogin() {
      let cookie = document.cookie;

      let arr = cookie.split(";");

      let res = arr.map(item => item.split("=")[0].trim());

      if (res.findIndex(item => item === "login_success") !== -1) {
        return true;
      }
      return false;
    },
    getCookie() {
      // function getCookie(cookie_name){
      //   var allcookies = document.cookie;
      //   var cookie_pos = allcookies.indexOf(cookie_name);   //索引的长度
      //
      //   if (cookie_pos != -1) {
      //     // 把cookie_pos放在值的开始，只要给值加1即可。
      //     cookie_pos += cookie_name.length + 1;      //这里容易出问题，所以请大家参考的时候自己好好研究一下
      //     var cookie_end = allcookies.indexOf(";", cookie_pos);
      //
      //     if (cookie_end == -1) {
      //       cookie_end = allcookies.length;
      //     }
      //
      //     var value = unescape(allcookies.substring(cookie_pos, cookie_end));         //这里就可以得到你想要的cookie的值了。。。
      //   }
      //   return value;
      // }

      // 调用函数
      let  loginState = this.checkLogin();

      // this.cookieInfo = document.cookie;
      if (!loginState) {
        this.isShow = true;
        this.isedShow = false;
      } else {
        this.isShow = false;
        this.isedShow = true;
      }
    },
    signOut() {
      let keys = document.cookie.match(/[^ =;]+(?=\=)/g);

      if (keys) {
        for (let i = keys.length; i--;) {
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
        }
      }
      location.reload();
      this.isShow = true;
      this.isedShow = false;
    },
    saveHoveredKey(key) {
      this.hoveredKey = key;
      if (this.hoveredKey) {
        const index = this.keyDict.indexOf(this.hoveredKey);

        if (index !== -1) {
          const showVariableKey = `show${index + 1}`;

          this.$set(this.showVariables, showVariableKey, true);
        }
      }
    },
    showDiv() {
      if (this.hoveredKey) {
        const index = this.keyDict.indexOf(this.hoveredKey);

        if (index !== -1) {
          const showVariableKey = `show${index + 1}`;

          this.$set(this.showVariables, showVariableKey, true);
        }
      }
    },
    hideDiv() {
      for (const key in this.showVariables) {
        this.showVariables[key] = false;
      }
    },
    productView() {
      let path = "/product";

      let index = "0";

      this.$router.push({path, query: {index}});
      this.reload();
    },
    productViewList(name,firstName) {
      let path = "/product";

      let index = "1";

      if (name === "双湃可信数据空间") {
        this.$router.push({path:"/space"});
      } else if (firstName === "工业等级保护"){
        this.$router.push({path, query: {index,activeKey: "2"}});
      } else {
        this.$router.push({path, query: {index,activeKey: "1"}});
      }
      this.reload();
    },
    productViewPlatform() {
      let path = "/product";

      let index = "2";

      this.$router.push({path, query: {index}});
      this.reload();
    },
    caseView() {
      this.$router.push("/case");
    },
    jumpServiceView(index, subIndex) {
      // window.localStorage.setItem("serviceTypeList", JSON.stringify(this.serviceTypeList));
      // window.localStorage.setItem("index", JSON.stringify(index));
      // window.localStorage.setItem("subIndex", JSON.stringify(subIndex));
      // this.$router.push({
      //   name: "serviceView",
      //   params: {
      //     index: index,
      //     subIndex: subIndex
      //   }
      // });
      this.$router.push({path: "/service/serviceView", query:{name: index,key:subIndex}});
      this.reload();
    },
    jumpSolutionView(activeName,activeKey) {
      this.$router.push({path: "/solution/solutionView", query:{name: activeName,key:activeKey}});
      this.reload();
    },
    jumpLapView(id) {
      this.$router.push({path: "/lab", query:{id: id}});
      this.reload();
    }
  }
};
</script>

<style scoped lang="less">
.header {
  -webkit-user-select:none;
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 65px;
  background: #292f3c;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .header-logo {
      margin-left: 36px;
    }
  }

  .menu-container {
    display: inline-block;
    //margin: 0 45px 0 auto;
    //.sm({
    //    margin: 0 20px 0 auto;
    //});
    margin: 0 200px;

    .menu {
      display: flex;
      margin: 0;
      padding: 0;
      line-height: 62px;

      li {
        padding: 0;
        margin: 0 44px 0 0;
        text-align: center;
        list-style: none;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;

        &:last-child {
          //.sm({
          //    margin: 0;
          //});
        }

        &.menu-item.active {
          border-bottom: 3px solid #f5b537;
        }
      }
    }
  }

  .phone {
    display: inline-block;
    height: 26px;
    width: 200px;
    background: #224895;
    border-radius: 53px;

    img {
      padding: 0 9px 0 12px;
      vertical-align: middle;
    }

    .tx {
      display: inline-block;
      vertical-align: middle;
      font-size: 15px;
      line-height: 26px;
      color: #ffffff;
    }
  }

  .btn-list {
    display: flex;
    align-items: center;
  }

  .login {
    border: 1px solid #ffffff;
    box-sizing: border-box;
    width: 85px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin: 0 5px;

    > span {
      color: #ffffff;
      font-size: 16px;
    }
  }

  .register {
    cursor: pointer;
    margin: 0 25px;

    > span {
      color: #ffffff;
      font-size: 16px;
    }
  }

  .regist {
    > span {
      color: #ffffff;
      font-size: 16px;
    }
  }

  .animated-div {
    width: 100%;
    background-color: #e2f2fa;
    transition: all 0.1s ease;
    position: absolute;
    top: 65px;
    z-index: 99999;
    .product-gap {
      padding-bottom: 65px;
    }
    .product-header-box-slide {
      display: flex;
      margin-left: 120px;
      flex-wrap: wrap;
      .full-scene {
        width: 442px;
        height: 100%;
        box-sizing: border-box;
        border-right: 1px solid #9ABED1;
        padding-left: 40px;
      }
      .educate-box {
        width: 390px;
        height: 100%;
        border-right: 1px solid #9ABED1;
        padding-left: 36px;
      }
      .region-box {
        width: 760px;
        padding-left: 47px;
        border-right: 1px solid #9ABED1;
        .region-item-box {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .region-item {
            margin-right: 60px;
          }
          .product-title {
            color:#292F3B;
            font-size:16px;
            line-height: 21px;
            margin-bottom: 12px;
          }
        }
      }
      .header-item {
        box-sizing: border-box;
        width: 268px;
        min-height: 159px;
        padding-left: 40px;
        border-right: 1px solid #9ABED1;
        margin-bottom: 65px;
      }
      .title {
        color: #000;
        font-family: OPPOSans;
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 26px;
      }
      .sub-title {
        color: #224895;
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 10px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .details {
      width: 184px;
      height: 47px;
      background: var(--blue, #224895);
      color: #FFF;
      font-size: 16px;
      text-align: center;
      line-height: 47px;
      cursor: pointer;
      margin-top: 25px;
    }
    .describe {
      color: #000000;
      font-size: 16px;
      line-height: 21px;
      width: 277px;
    }
    .line {
      width: 1px;
      height: 290px;
      background: #9ABED1;
      margin: 0 60px 0 60px;
    }
    .line-light {
      width: 1px;
      height: 290px;
      background: #9ABED1;
      margin: 0 50px 0 50px;
    }
  }

  .animated-box {
    padding-top: 35px;
  }
  .animated-bg {
    position: absolute;
    top:0;
    left:0;
    z-index: -1;
    background-image: url("../assets/assetsNewImg/index/header-bg.png");
    background-size: cover;
    background-position: left bottom;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    opacity: 0.15;
  }
}
</style>
